import handleResponse from './request/handleResponse'

export default function(api: GlobalFetch) {
  return async function(values) {
    const response = await api.fetch(`/api/v2/booking/index`, {
      method: 'POST',
      body: JSON.stringify({
        ...values,
      }),
    })
    return await handleResponse(response)
  }
}
